import React from 'react';
import HeroFooter from './footer';
import RefundStrip from './refund-strip';
import HeroLottie from './lottie';
import HeroHeading from './heading';
import { AnimatedContainer } from './styles';
import { HeroSectionProps } from './types';
import { useRefundAmount } from '../../../../hooks/useRefundAmount';

const HeroSection: React.FC<HeroSectionProps> = ({ constants }) => {
  const {
    refundAmount,
    platformLogos,
    statistics,
    platformText,
    subheading,
    heading_h1,
  } = constants;
  const refund = useRefundAmount(refundAmount);
  return (
    <AnimatedContainer>
      <div className="bg-pink-brand">
        <div className="relative bg-no-repeat bg-right-top">
          <h1 className="sm:block hidden pt-5 text-center text-base font-medium">
            {heading_h1}
          </h1>
          <div className="flex justify-between bg-pink-brand sm:w-full wg-container mx-auto sm:h-[531px] xl:h-[529px] lg:h-[494px] md:h-[320px]">
            <div className="sm:pt-2 sm:px-4 sm:w-full flex flex-col lg:pl-0 lg:pr-0 md:pl-5 sm:pl-0 sm:pr-0 sm:items-center sm:text-center lg:w-1/2">
              <RefundStrip
                refundAmount={refund?.refund_amount}
                heading_h1={heading_h1}
              />

              <HeroHeading subheading={subheading} />

              <HeroLottie className="hidden sm:block pl-[61px] h-[294px] opacity-0 translate-y-12 animate-[slideIn_0.8s_ease-out_forwards] pointer-events-none sm:absolute sm:bottom-0" />
            </div>

            <HeroLottie
              className="hidden lg:block xl:h-[529px] opacity-0 translate-y-12 animate-[slideIn_0.8s_ease-out_forwards] lg:h-[494px] xl:block lg:items-end md:block md:pr-3 md:w-[320px] pointer-events-none"
              id="lottie-container"
            />
          </div>
        </div>

        <HeroFooter
          platformText={platformText}
          platformLogos={platformLogos}
          statistics={statistics}
          classname="md:pt-7"
        />
      </div>
    </AnimatedContainer>
  );
};

export default HeroSection;
